// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"LogoutModal_modalContainer__10Mai","closeButton":"LogoutModal_closeButton__1eaXO","logoutText":"LogoutModal_logoutText__1PcaT"};